import { render, staticRenderFns } from "./NewCreateGestaoDeAuxiliares.vue?vue&type=template&id=a97529fa"
import script from "./NewCreateGestaoDeAuxiliares.vue?vue&type=script&lang=js"
export * from "./NewCreateGestaoDeAuxiliares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports